import { render, staticRenderFns } from "./AddPriceModal.vue?vue&type=template&id=41d4354c&"
import script from "./AddPriceModal.vue?vue&type=script&lang=js&"
export * from "./AddPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports